import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'dual-pagination',
  templateUrl: './dual-pagination.component.html',
  styleUrls: ['./dual-pagination.component.scss']
})
export class DualPaginationComponent implements OnInit {

  @Input() totalElements: number | undefined
  @Input() totalElementsTab2: number | undefined
  @Input() totalElementsTab3: number | undefined
  @Input() pageSize: number = 10
  @Input() padding: boolean = true
  @Input() tab: number | undefined

  total: number | undefined
  pagesTotal: number[] = []
  pages: number[] = []
  page: number = 1
  @Output() selectPage: EventEmitter<any> = new EventEmitter();

  constructor() {
  }

  ngOnInit() {
    console.log('tab-pagination init')
  }

  ngOnChanges() {
    this.load()
  }

  load(){
    this.pagesTotal = []
    this.pages = []

    if(this.totalElements){
      this.total = this.totalElements / this.pageSize
    }

    if(this.totalElementsTab2){
      this.total = this.totalElementsTab2 / this.pageSize
    }

    
    if(this.totalElementsTab3){
      this.total = this.totalElementsTab3 / this.pageSize
    }
    // @ts-ignore
    for (let i = 0; i < this.total; i++) {
      this.pagesTotal.push(i + 1)
    }
    this.reduce(5, 3)
  }

  reduce(size: number, position: number) {
    this.pages = this.pagesTotal.filter(el => {
      return (position - 1 <= el && el <= position + 1) || el == 1 || el == this.pagesTotal.length
    })
  }

  getPosition(page: number): number {
    let radio = 1
    let position = 3
    if (page == 1 || page == 2) {
      position = 3
    } else {
      if (page == this.pagesTotal.length || page == this.pagesTotal.length - 1) {
        position = this.pagesTotal.length - 2
      } else {
        position = page
      }
    }
    return position
  }

  changePage(page: number) {
    this.page = page
    this.selectPage.emit(this.page)
    this.reduce(5, this.getPosition(page))
  }

  next() {
    if (this.page >= 1 && this.page < this.pagesTotal.length) {
      this.changePage(this.page + 1)
    }
  }

  prev() {
    if (this.page > 1 && this.page <= this.pagesTotal.length) {
      this.changePage(this.page - 1)
    }
  }

  prevBool(): boolean {
    return this.page > 1 && this.page <= this.pagesTotal.length
  }

  nextBool(): boolean {
    return (this.page >= 1 && this.page < this.pagesTotal.length)
  }

}
